import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/table.tsx
function n({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "table-wrapper",
		className: "overflow-x-visible",
		children: /* @__PURE__ */ t("table", {
			"data-slot": "table",
			className: e("w-full border-collapse", n),
			...r
		})
	});
}
function r({ className: n, ...r }) {
	return /* @__PURE__ */ t("thead", {
		"data-slot": "table-header",
		className: e("bg-(--neutral-50) *:[tr]:border-b-0", n),
		...r
	});
}
function i({ className: n, ...r }) {
	return /* @__PURE__ */ t("tbody", {
		"data-slot": "table-body",
		className: e(n),
		...r
	});
}
function a({ className: n, ...r }) {
	return /* @__PURE__ */ t("tr", {
		"data-slot": "table-row",
		className: e("border-b border-(--neutral-100) hover:bg-(--neutral-50)", n),
		...r
	});
}
function o({ className: n, ...r }) {
	return /* @__PURE__ */ t("th", {
		"data-slot": "table-head",
		className: e("px-4 py-3 text-left font-md-14", "first:rounded-tl-xl last:rounded-tr-xl", "[&:not(:first-child):not(:last-child)]:text-right", n),
		...r
	});
}
function s({ className: n, ...r }) {
	return /* @__PURE__ */ t("td", {
		"data-slot": "table-cell",
		className: e("px-4 py-3 font-reg-14", "not-first:[td]:text-right", n),
		...r
	});
}
//#endregion
export { n as Table, i as TableBody, s as TableCell, o as TableHead, r as TableHeader, a as TableRow };
